import { render, staticRenderFns } from "./ImportEmployees.vue?vue&type=template&id=68753e54&scoped=true&"
import script from "./ImportEmployees.vue?vue&type=script&setup=true&lang=js&"
export * from "./ImportEmployees.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ImportEmployees.vue?vue&type=style&index=0&id=68753e54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68753e54",
  null
  
)

export default component.exports